import React, { useState, Suspense } from "react";
import ReactDOM from "react-dom";
import { popup } from "venuescanner-js/vanilla/components/popup";
import Loading from "venuescanner-js/react/components/Loading";
import Login from "./LoadableLogin";
import Register from "./LoadableRegister";
import classes from "./styles.module.scss";

// import Modal from 'venuescanner-js/react/components/Modal'

const Logo = () => (
  <a href="/" className={classes.auth__logo}>
    &nbsp;
  </a>
);
const views = {
  LOGIN: "login",
  REGISTER: "register",
};
const Auth = ({ showSignIn = true, afterLogin }) => {
  const [view, setView] = useState(showSignIn ? views.LOGIN : views.REGISTER);
  return (
    <>
      <Logo />
      <div>
        {view === views.LOGIN ? (
          <Login
            sent={(data) => {
              if (afterLogin) afterLogin({ login: data });
              popup.close();
            }}
            showRegister={() => {
              setView(views.REGISTER);
            }}
          />
        ) : null}
        {view === views.REGISTER ? (
          <Register
            sent={(data) => {
              if (afterLogin) afterLogin({ login: data });
              popup.close();
            }}
            showLogin={() => {
              setView(views.LOGIN);
            }}
          />
        ) : null}
      </div>
    </>
  );
};

const signIn = ({ showSignIn = true, afterLogin }) => {
  if (window.isLoggedIn){
    return;
  }

  const currentPath = window.location.href;
  window.location.href = `/login?redirect=${encodeURIComponent(currentPath)}`;

};

export default signIn;
